export default __webpack_public_path__ + "img/glo.8ab20383.png";